import { Col, Container, Row } from "react-bootstrap";
import { getAwards } from "@/functions/getAwards";
import { useLocale } from "@/hooks/useLocale";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { DynamicHtml } from "@/ui/DynamicHtml";

export const AwardsPageFeedSection = ({ className }) => {
  const locale = useLocale();
  const awards = getAwards();

  return (
    <div className={className}>
      <Container>
        <DynamicHtml path={`page.awards.feed.text.${locale}`} tag="p" className="mb-4" />
        <Row>
          {awards.map((i, k) => (
            <Col key={k} xs={12} md={3} className={clsx(classes.card, "pt-5 pb-4")}>
              <figure>
                <div
                  className="d-flex align-items-end justify-content-center align-items-center pb-3"
                  style={{ height: 150 }}
                >
                  <img
                    src={i.image}
                    alt={i[`title_${locale}`]}
                    title={i[`title_${locale}`]}
                    className="mw-100 mh-100"
                  />
                </div>
                <figcaption className="d-block text-center fw-semibold px-3">{i[`title_${locale}`]}</figcaption>
              </figure>
            </Col>
          ))}
        </Row>
        <DynamicHtml path={`page.awards.feed.footer.${locale}`} tag="p" className="mt-4" />
      </Container>
    </div>
  );
};
